import { IChartData } from "@/models/Charts/ChartData";
import { RepairOrder } from "@/services/api";
import _ from "lodash";
import * as React from "react";
import format from "date-fns/format";
import addMonths from "date-fns/addMonths";
import { BarChart } from "../../molecules/Charts/BarChart";
import Rand from "rand-seed";
export interface IRosByServiceProps {
	repairOrders: RepairOrder[];
	loading?: boolean;
	title?: string;
}

export function RosByService({ repairOrders, loading, title }: IRosByServiceProps) {
	const chartData = React.useMemo<IChartData>(() => {
		if (loading) {
			const labels = Array.from(Array(5).keys()).map((i, index) => {
				return "Service " + (i + 1);
			});
			const rand = new Rand("submitted");
			const cd: IChartData = {
				key: "loading-data",
				items: [
					{
						values: labels.map((i) => Math.round(rand.next() * 10)),
						color: "#eee",
					},
				],
				labels,
			};

			return cd;
		}

		const labels = _.uniq(repairOrders.map((i) => i.requestType!)).sort();
		return {
			items: [
				{
					values: labels.map((i) => repairOrders.filter((j) => j.requestType === i).length),
				},
			],
			labels,
		};
	}, [repairOrders, loading]);

	return <BarChart title={title} data={chartData} />;
}
